exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.register-notif {\n  color: #444;\n  background-color: #fff;\n  border: 2px solid #ddd;\n  border-radius: 10px;\n  padding: 30px 30px;\n  box-shadow: 0 4px 21px -12px rgb(0 0 0 / 66%);\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n.notif-title {\n  font-weight: bold;\n}\n.notif-detail {\n  text-transform: none;\n  font-weight: 400;\n}\n.notif-qrcode img {\n  width: 50%;\n}\n.notif-note {\n  font-size: 11px;\n}\n@media screen and (max-width: 768px) {\n.notif-qrcode img {\n    width: 100%;\n}\n}\n", ""]);

// exports
